/* eslint-disable @typescript-eslint/no-empty-function */
import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import clx from "classnames";
import styles from "./Modal.module.css";

interface Props {
    children: (({ onClose }: { onClose: () => void }) => React.ReactNode) | React.ReactNode;
    className?: string;
    childClassName?: string;
    show?: boolean;
    onClose?: () => void;
    contain?: boolean;
    full?: boolean;
    overflowYAuto?: boolean;
    initialFocusRef?: React.MutableRefObject<HTMLElement | null>;
}

const Modal = ({
    children,
    show = false,
    className = "",
    onClose = () => {},

    contain = false,
    full,
    overflowYAuto = true,
    initialFocusRef,

    childClassName = "p-0.5 sm:p-1 md:p-2",
}: Props) => {
    const cn = clx(
        {
            "max-w-2xl": contain === true,
            "max-w-none": contain === false,
            "w-full": full,
        },
        // center flex
        "relative z-10 px-32 py-12 flex justify-center items-center",
        styles.modal
    );

    return (
        <Transition appear show={show} as={Fragment}>
            <Dialog
                data-testid="modal-dialog"
                as="div"
                className={`relative z-dialogPanels ${className}`}
                onClose={onClose}
                initialFocus={initialFocusRef}
            >
                <div
                    className={`fixed inset-0 backdrop-blur-sm flex items-center justify-center p-0.5 sm:p-1 md:p-2 ${childClassName} ${
                        overflowYAuto ? "overflow-y-auto" : ""
                    }`}
                >
                    <div className="fixed inset-0 bg-midnight-500 opacity-60 " />
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className={cn}>{typeof children === "function" ? children({ onClose }) : children}</Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
};

export default Modal;
